import { useCallback, useLayoutEffect, useState } from 'react'

import InterWebviewBridge, {
  interWbSession,
  WbEnvironments,
  IWbUserInfo,
} from '@interco/inter-webview-bridge'

import { userInfoMock } from '../mocks/userInfo'

export const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState<IWbUserInfo>({} as IWbUserInfo)

  const interWb = InterWebviewBridge.getInstance()

  const getUserInfo = useCallback(async () => {
    const isDev = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
    const isMock =
      isDev &&
      (process.env.REACT_APP_MOCK_ENABLED === 'true' ||
        interWb.getEnvironment() === WbEnvironments.BROWSER)

    if (isMock) {
      setUserInfo(userInfoMock)
    } else {
      const data = await interWbSession.getUserInfo()
      setUserInfo(data)
    }
  }, [interWb])

  useLayoutEffect(() => {
    getUserInfo()
  }, [getUserInfo])

  return userInfo
}
